import React, { useState } from 'react';
import { DateRangePicker as ExternalDateRangePicker, DateRangePickerShape as ExternalDateRangePickerShape } from 'react-dates';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import './DatePicker.scss';
import 'react-dates/lib/css/_datepicker.css';

export interface DateRangePickerProps extends Omit<ExternalDateRangePickerShape, "focusedInput" | "onFocusChange" | "endDateId" | "startDateId"> { 
    label?: string;
    name: string;
    focusedInput?: DateRangeFocus;
    onFocusChange?: (args: DateRangeFocus) => void;
};

type DateRangeFocus = 'startDate' | 'endDate' | null;

export const DateRangePicker: React.FC<DateRangePickerProps> = (props) => {

    const [internalFocused, setInternalFocused] = useState<DateRangeFocus>(null);

    function internalOnFocusedChange (arg: DateRangeFocus) {
        setInternalFocused(arg);
    }

    //determine whether we're in controlled vs uncontrolled focus state
    //trust props first, then fallback on uncontrolled by maintaining state ourselves.
    let onFocusChange = props.onFocusChange || internalOnFocusedChange;
    let focusedInput: DateRangeFocus;
    if (props.focusedInput === undefined || props.focusedInput === null) {
        focusedInput = internalFocused;
    } else {
        focusedInput = props.focusedInput;
    }

    let startDateId = props.name + '_startId';
    let endDateId = props.name + '_endId';
    
    //spread props last, so the caller can override our internal onFocusChange/focused props
    return (
        <FormGroup>
            { props.label && <ControlLabel>{props.label}</ControlLabel> }
            <div>
                <ExternalDateRangePicker 
                    numberOfMonths={2}
                    isOutsideRange={() => false}
                    onFocusChange={onFocusChange}
                    focusedInput={focusedInput} 
                    startDateId={startDateId}
                    endDateId={endDateId}
                    {...props} />
            </div>
        </FormGroup>
    )
}

(DateRangePicker as any).displayName = 'DateRangePicker' //for react dev tools

/*

Here is the minimum REQUIRED setup you need to get the DateRangePicker working:

<DateRangePicker
  startDate={this.state.startDate} // momentPropTypes.momentObj or null,
  endDate={this.state.endDate} // momentPropTypes.momentObj or null,
  name="my_date" //PropTypes.string.isRequired, used for start and end dates
  onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired
/>

*/